module.exports = __webpack_public_path__ + "static/img/our-customers-infrastructure.75a2c97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/our-customers-infrastructure.jpg
// module id = oOLS
// module chunks = 0